import { formatCurrency } from '@/utils';

export default {
  beforeList: ({ form }) => {
    form.total_inputs = formatCurrency(form.total_inputs);
    form.total_outputs = formatCurrency(form.total_outputs);
    form.balance = formatCurrency(form.balance);
  },
};
